import { useGetCurrentUserQuery } from "@/shared/services";
import {
  isOnboardingCohort,
  useIsOnboardingCohort,
} from "@features/onboarding/cohort";
import { useEffect } from "react";
import { ONBOARDING_GROUP_PROP } from "../onboarding-events.constants";
import { register } from "../utils";

/**
 * `onboarding` sees the post-conversion onboarding (cohort + flag, or the admin
 * override); `flag off` is a cohort-age account without it; `existing` predates it.
 */
export const useRegisterOnboardingGroup = (authenticated = false): void => {
  const { data: user } = useGetCurrentUserQuery();
  const sees = useIsOnboardingCohort(user?.createdAt);

  useEffect(() => {
    if (!authenticated || !user) return;
    const group = sees
      ? "onboarding"
      : isOnboardingCohort(user.createdAt)
        ? "flag off"
        : "existing";
    register({ [ONBOARDING_GROUP_PROP]: group });
  }, [authenticated, user, sees]);
};
